import React from 'react'
import { Box, SxProps, Tooltip } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ShopQuantityAvailableTypes } from '../../types'
import { E3dcAvailability } from '../../models/power-meter.model'

interface QuantityAvailabilityIndicatorProps {
  quantityAvailableType?: E3dcAvailability | undefined
  sx?: SxProps
}

const useStyles = makeStyles()(theme => ({
  dotsContainer: {
    display: 'inline-flex',
    marginLeft: theme.spacing(1),
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  dot: {
    width: '12px',
    height: '12px',
    borderRadius: theme.shape.borderRadius,
  },
  greenDot: {
    backgroundColor: theme.palette.success.main,
  },
  yellowDot: {
    backgroundColor: theme.palette.warning.main,
  },
  redDot: {
    backgroundColor: theme.palette.error.main,
  },
}))

/*
 * This component Shows 1 Dot (Indicator) with 3 different colors for product qunatity
 * 1. Red - Stands for at least more than 5 products available.
 * 2. Yellow - Stands for the last products 1 - 2
 * 3. Red - Stands when there is no product available
 */
const QuantityAvailabilityIndicator: React.VFC<QuantityAvailabilityIndicatorProps> = ({ quantityAvailableType, sx }) => {
  const { classes } = useStyles()
  const quantityAvailableColor = quantityAvailableType?.color ?? ShopQuantityAvailableTypes.OutOfStock
  const quantityAvailableTooltipText = quantityAvailableType?.colorText ?? ''

  const getDotStyle = (): string => {
    switch (quantityAvailableColor) {
      case ShopQuantityAvailableTypes.Available:
        return classes.greenDot
      case ShopQuantityAvailableTypes.FewLeft:
        return classes.yellowDot
      case ShopQuantityAvailableTypes.OutOfStock:
        return classes.redDot
      default:
        return classes.redDot
    }
  }

  return (
    <Tooltip sx={sx} placement="top" title={quantityAvailableTooltipText} className={classes.dotsContainer}>
      <Box>
        <span className={`${classes.dot} ${getDotStyle()}`} />
      </Box>
    </Tooltip>
  )
}

export default QuantityAvailabilityIndicator
